import { render, staticRenderFns } from "./SubmitDeclarationsModal.vue?vue&type=template&id=5fc3bd82&scoped=true&"
import script from "./SubmitDeclarationsModal.vue?vue&type=script&lang=js&"
export * from "./SubmitDeclarationsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc3bd82",
  null
  
)

export default component.exports